export default __webpack_public_path__ + "static/media/pintura.4aeeeba4.jpg";